<template>
  <div>
    <div class="content1">
      <header-component  pageType="solution-write" :menuIndex="1"/>
      <nav class=" flex flex-column flex-align-center" style="width: 80%;margin: 0 auto;">
        <div class="nav-txt" data-aos="fade-up">{{ $t('solution5.nav.title') }}</div>
        <div class="nav-txt" data-aos="fade-up" data-aos-delay="100">{{ $t('solution5.nav.subtitle') }}<div class="txt1">{{ $t('solution5.nav.highlight') }}</div></div>
        <div class="desc" data-aos="fade-up" data-aos-delay="200">{{ $t('solution5.nav.desc') }}</div>
        <div class="ty" data-aos="fade-up" data-aos-delay="300" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution5.nav.btn') }}</div>
      </nav>
    </div>
    <div class="content2 flex flex-column flex-align-center">
      <h1 data-aos="fade-up">{{ $t('solution5.content2.title') }}</h1>
      <div class="flex flex-justify-between flex-align-center item">
        <div class="flex flex-column" data-aos="fade-up" data-aos-delay="100">
          <div class="txt1">{{ $t('solution5.content2.item1.title') }}</div>
          <div class="txt2">{{ $t('solution5.content2.item1.desc') }}</div>
        </div>
        <img src="@/assets/image/solution5/Slice 42@2x.png" data-aos="fade-up" data-aos-delay="200"/>
      </div>
      <div class="flex flex-justify-between flex-align-center item item1">
        <img src="@/assets/image/solution5/Slice 41@2x.png" data-aos="fade-up"/>
        <div class="flex flex-column flex-align-end" data-aos="fade-up" data-aos-delay="300">
          <div class="txt1">{{ $t('solution5.content2.item2.title') }}</div>
          <div class="txt2">{{ $t('solution5.content2.item2.desc') }}</div>
        </div>
      </div>
    </div>
    <div class="content3 flex flex-column flex-align-center ">
      <div class="flex flex-column item-nav-top" data-aos="fade-up" data-aos-delay="100">
        <h1 data-aos="fade-up">{{ $t('solution5.content3.title') }}</h1>
        <h2 data-aos="fade-up" data-aos-delay="200">{{ $t('solution5.content3.subtitle') }}</h2>
        <img src="@/assets/image/solution5/Slice 41@2x(1).png" class="img1"/>
        <div class="connect" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution5.content3.connect') }}</div>
        <div class="txt1">{{ $t('solution5.content3.item1.title') }}</div>
        <div class="txt2">{{ $t('solution5.content3.item1.desc') }}</div>
        <!-- <div class="ty" @click="$refs.connectRef.toConnectIndex()">立即体验</div> -->
      </div>
      <div class="flex flex-column item-nav-bot" data-aos="fade-up">
        <div class="flex">
          <img src="@/assets/image/solution5/Slice 41@2x(2).png" class="img2"/>
          <div class="flex flex-column">
            <div class="txt3">{{ $t('solution5.content3.items.0.title') }}</div>
            <div class="txt4">{{ $t('solution5.content3.items.0.desc') }}</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/image/solution5/Slice 41@2x(3).png" class="img2"/>
          <div class="flex flex-column">
            <div class="txt3">{{ $t('solution5.content3.items.1.title') }}</div>
            <div class="txt4">{{ $t('solution5.content3.items.1.desc') }}</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/image/solution5/Slice 41@2x(4).png" class="img2"/>
          <div class="flex flex-column">
            <div class="txt3">{{ $t('solution5.content3.items.2.title') }}</div>
            <div class="txt4">{{ $t('solution5.content3.items.2.desc') }}</div>
          </div>
        </div>
      </div>
    </div>
    <connect-component ref="connectRef" @kf="$refs.connectRef.toConnectIndex()"></connect-component>
    <kf-component kf-top="1086px" ref="kfContainer"></kf-component>
  </div>
</template>
<script>
export default {
  name: 'solution5-page',
  data() {
    return {
      
    }
  }
}
</script>
<style lang="less" scoped>
.content1{
  min-height: 1175px;
  background: url('@/assets/image/solution5/Slice 37@2x.png') no-repeat center/100% 100%;
  nav {
    padding-top: 212px;
  
    .nav-txt {
      font-weight: bold;
      font-size: 60px;
      color: #FFFFFF;
      line-height: 90px;
      text-align: center;
      .txt1{
        color: #C085FF;
        display: inline-block;
      }
    }
    .desc{
      width: 60%;
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 20px;
      color: #8C898E;
      line-height: 40px;
      margin-top:20px;
    }
  
    .ty {
      position: relative;
      width: 257px;
      height: 44px;
      line-height: 44px;
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 17px;
      color: #fff;
      letter-spacing: 12px;
      text-align: center;
      /* 设置内部背景色 */
      border-radius: 62px;
      /* 圆角 */
      overflow: hidden;
      /* 确保伪元素不会溢出 */
      z-index: 1;
      /* 确保内容在伪元素之上 */
      margin-top: 20px;
      cursor: pointer;
    }
  
    .ty::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 62px;
      /* 圆角与主元素保持一致 */
      padding: 2px;
      /* 边框宽度 */
      background: linear-gradient(90deg, rgba(255, 132, 194, 1), rgba(160, 43, 254, 1));
      /* 渐变边框 */
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      /* 遮罩 */
      -webkit-mask-composite: destination-out;
      mask-composite: exclude;
      /* 遮罩组合 */
      z-index: -1;
      /* 伪元素位于内容之下 */
    }
  }
}
.content2{
  background-color: #fff;
  h1{
    margin: 104px 0 88px;
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 40px;
    color: #000000;
  }
  .item{
    width: 876px;
    padding: 0 62px;
    margin-bottom: 141px;
    img{
      width: 437px;
    }
    .txt1{
      font-family: Plus Jakarta Sans, Plus Jakarta Sans;
      font-weight: bold;
      font-size: 28px;
      color: #000000;
      line-height: 33px;
      margin-bottom: 20px;
    }
    .txt2{
      font-family: Plus Jakarta Sans, Plus Jakarta Sans;
      font-weight: 400;
      font-size: 20px;
      color: #51545A;
      line-height: 40px;
      max-width: 343px;
    }
  }
  .item1{
    img{
      width: 397px;
    }
    .txt2{
    max-width: 431px;
  }
  }
}
.content3{
  .item-nav-top{
    width: 640px;
    margin-bottom: 63px;
    padding: 0 181px;
    h1{
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 40px;
      color: #000000;
      text-align: center;
    }
    h2{
      font-family: Nunito Sans, Nunito Sans;
      font-weight: 400;
      font-size: 24px;
      color: #979797;
      margin: 18px 0 100px;
      text-align: center;
    }
    .img1{
      width: 640px;
      /** margin-right: 120px; **/
    }
    .connect{
      width: 141px;
      height: 38px;
      background: linear-gradient( 90deg, #FC7476 2%, #6F43D5 100%);
      border-radius: 60px 60px 60px 60px;
      font-family: Inter, Inter;
      font-weight: normal;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 38px;
      text-align: center;
      margin: 41px 0 21px;
      cursor: pointer;
    }
    .txt1{
      font-family: Poppins, Poppins;
      font-weight: bold;
      font-size: 26px;
      color: #000000;
      line-height: 47px;
    }
    .txt2{
      max-width: 609px;
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 20px;
      color: #51545A;
      line-height: 36px;
      margin: 20px 0 39px;
    }
    .ty{
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 20px;
      color: #AC63FB;
      line-height: 36px;
      letter-spacing: 8px;
      text-align: left;
      font-style: normal;
      text-decoration-line: underline;
      text-transform: none;
      cursor: pointer;
      text-align: center;
    }
  }
  .item-nav-bot{
    margin-bottom: 60px;
    .img2{
      width: 280px;
      margin-bottom: 50px;
      margin-right: 40px;
    }
    .txt3{
      font-family: Poppins, Poppins;
      font-weight: bold;
      font-size: 22px;
      color: #000000;
      margin-bottom: 60px;
    }
    .txt4{
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 20px;
      color: #51545A;
      line-height: 36px;
      max-width: 447px;
    }
  }
}
</style>